import { BrowserRouter, Route, Routes } from "react-router-dom";
import Main from "../core/Main/Main";
import HomePage from "../components/HomePage/Homepage";
import Aboutus from "../shared/components/Home/Aboutus";
import Ourgallery from "../shared/components/Home/Ourgallery";
import ApplicationformPage from "../components/ApplicationformPage/Applicationformpage";
import Studymaterials from "../shared/components/Home/StudyMaterials";
import Loginform from "../shared/components/Loginform/Loginform";
import ProtectedRoute from "../shared/services/token/ProtectedRoute";
import AdminRouter from "../admin/AdminRouter/Adminrouter";
import RegisterFormPage from "../components/RegisterFormPage/Registerformpage";
import VerifyOtp from "../shared/components/RegisterForm/veifyOtp";
import MyAccount from "../components/MyAccount/Myaccount";
import Myorders from "../components/MyOrders/Myorders";
import { ForgotPassword } from "../shared/components/Loginform/Forgotpassword";
import { VerifyForgotPasswordOTP } from "../shared/components/Loginform/VerifyForgotPasswordOTP";
import { ResetPassword } from "../shared/components/Loginform/ResetPassword";
import Viewproductfunction from "../components/ViewProductFunction/Viewproductfunction";
import TermsandConditions from "../shared/components/PrivacyRefundT&CPages/Termsandconditions";
import PrivacyPolicy from "../shared/components/PrivacyRefundT&CPages/PrivacyPolicy";
import Refundpolicy from "../shared/components/PrivacyRefundT&CPages/Refundpolicy";
import CurrentAffHomePage from "../components/Currentaffairspage";
import CurrentAffairsDetail from "../shared/components/Current-Affairs/CurrentAffairsDetail";
import MonthlyCurrentAffairs from "../shared/components/Current-Affairs/MonthlyCurrentAffairs";
import { MonthlyCurrentAffairsDetail } from "../shared/components/Current-Affairs/MonthlyCurrentAffairsDetail";
import Testseriespage from "../components/TestSeriespage";
import Testdetailpage from "../shared/components/Home-Test-Series/TestDetailpage";
import Testpage from "../shared/components/Home-Test-Series/Testpage";
import TestResultpage from "../shared/components/Home-Test-Series/TestResultpage";
import ScrollToTop from "./Scrolltotop";
import PreviousYearpaperpage from "../components/PreviousYearPaperpage";
import Pyqdetailpage from "../shared/components/Previous-year-papers/Pyqdetailpage";
import PyqPapersPage from "../shared/components/Previous-year-papers/PyqPapersPage";
import StudyHallMain from "../core/StudyHall/Main";
import Homepage from "../shared/components/Athena-study-hall/Homepage";
import Bookseats from "../shared/components/Athena-study-hall/Bookseats";
import StudyHallGallery from "../shared/components/Athena-study-hall/Gallery";
import { SidebarProvider } from "../core/Sidebar/SidebarContext";
import DownloadsPage from "../shared/components/Current-Affairs/Downloads";

export default function Approuter() {

    return (
        <BrowserRouter>
        <SidebarProvider>
         <ScrollToTop/>
            <Routes>
                <Route element={<Main />}>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/aboutus" element={<Aboutus />} />
                    <Route path="/gallery" element={<Ourgallery />} />
                    <Route path="/application-form" element={<ApplicationformPage />} />
                    <Route path="/study-materials" element={<Studymaterials />} />
                    <Route path="/login" element={<Loginform />} />
                    <Route path="/terms-and-conditions" element={<TermsandConditions/>}/>
                    <Route path="/privacy-policy" element={<PrivacyPolicy/>}/>
                    <Route path="/refund-cancellation-policy" element={<Refundpolicy/>}/>
                    <Route path="/register" element={<RegisterFormPage/>}/>
                    <Route path="/myaccount" element={<MyAccount/>}/>
                    <Route path="/myorder" element={<Myorders/>}/>
                    <Route path="/verify-otp" element={<VerifyOtp/>}/>
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/verify-forgot-password" element={<VerifyForgotPasswordOTP />} />
                    <Route path="/reset-password" element={<ResetPassword />} />
                    <Route path="/view-product/:id" element={<Viewproductfunction/>}/>
                    <Route path="/current-affairs" element={<CurrentAffHomePage/>}/>
                    <Route path="/downloads" element={<DownloadsPage/>}/>
                    <Route path="/current-affairs-detail/:id" element={<CurrentAffairsDetail />} />
                    <Route path="/monthly-current-affairs" element={<MonthlyCurrentAffairs/>} />
                    <Route path="/monthly-current-affairs/:monthParam" element={<MonthlyCurrentAffairsDetail />} />
                    <Route path="/online-test-series" element={<Testseriespage />} />
                    <Route path="/online-test-series/:slug" element={<Testdetailpage />} />
                    <Route path="/test-result" element={<TestResultpage />} />
                    <Route path="/previous-year-papers" element={<PreviousYearpaperpage />} />
                    <Route path="/pyq-details/:slug" element={<Pyqdetailpage/>} />
                    <Route path="/pyq-papers/:slug/:sectionId" element={<ProtectedRoute allowedRoles={['Admin', 'Student', 'Customer']}><PyqPapersPage /></ProtectedRoute> } />
                </Route>
                <Route element={<StudyHallMain/>}>
                    <Route path="/athena-study-hall" element={<Homepage/>}/>
                    <Route path="/athena-study-hall/book-seats" element={<Bookseats/>}/>
                    <Route path="/athena-study-hall/gallery" element={<StudyHallGallery/>}/>
                </Route>
                <Route path="/online-test-series/:slug/test/:testId" element={<ProtectedRoute allowedRoles={['Admin', 'Student', 'Customer']}><Testpage /></ProtectedRoute> } />
                <Route
                    path="/dashboard/*"
                    element={
                        <ProtectedRoute allowedRoles={['Admin']['Student']}>
                            <AdminRouter />
                        </ProtectedRoute>
                    }
                />
            </Routes>
            </SidebarProvider>
        </BrowserRouter>
    )
}
